import { Injectable } from "@angular/core";

interface ICookieOptions {
  expires?: string;
  path?: string;
  domain?: string;
  "Max-Age"?: string;
  Secure?: boolean;
  HttpOnly?: boolean;
  SameSite?: "Strict" | "Lax" | "None";
}

@Injectable({
  providedIn: "root"
})
export class CookieService {
  constructor() {}

  getCookie(name: string) {
    let cookies = {};
    const cookieString = document.cookie;
    cookieString.split("; ").forEach(cookie => {
      const [key, value] = cookie.split("=");
      cookies[key] = value;
    });
    return cookies[name] || undefined;
  }

  setCookie(name: string, value: string, options?: ICookieOptions): void {
    let cookieStr = `${name}=${value};`;
    if (options) {
      const optsSelected = Object.keys(options);
      for (const opt of optsSelected) {
        cookieStr += ` ${opt}${(typeof options[opt] === "string" && `=${options[opt]}`) || ""};`;
      }
    }
    document.cookie = cookieStr;
  }
}
